/* Tessera della dashboard: un numero, il suo verdetto, il suo qualificatore.
 *
 * I tre pezzi sono OBBLIGATORI nella firma. È la stessa idea di
 * `NumeroConSoglia`: se il verdetto e il qualificatore fossero opzionali,
 * prima o poi una tessera mostrerebbe il numero da solo — e un numero da solo,
 * su questa schermata, è quello che fa credere che vada tutto bene.
 *
 * Il qualificatore porta sempre l'ORA DI LETTURA: le quattro fonti della
 * dashboard rispondono in momenti diversi, quindi non esiste "adesso" comune.
 */

import type { ReactNode } from 'react';
import { Scheletro } from '../../componenti/Stati';
import type { Tono } from '../../lib/metriche';
import type { StatoDati } from '../../api/usaRichiesta';

export function Tessera({
  etichetta,
  valore,
  verdetto,
  qualificatore,
  tono = 'neutro',
  stato = 'pieno',
  azione,
}: {
  etichetta: string;
  valore: ReactNode;
  /** Cosa SIGNIFICA il numero. Sempre a video. */
  verdetto: string;
  /** Su cosa è calcolato e quando è stato letto. Sempre a video. */
  qualificatore: string;
  tono?: Tono;
  stato?: StatoDati;
  azione?: ReactNode;
}) {
  return (
    <div className={`sb-d-tessera${tono === 'cautela' ? ' sb-d-tessera--cautela' : ''}`}>
      <div className="sb-etichetta">{etichetta}</div>

      {stato === 'caricamento' ? (
        <>
          <Scheletro larghezza="60%" altezza={20} />
          <Scheletro larghezza="85%" altezza={10} />
          <Scheletro larghezza="70%" altezza={9} />
        </>
      ) : (
        <>
          <div className={`sb-d-tessera__valore sb-tono-${tono}`}>{valore}</div>
          <div className={`sb-d-tessera__verdetto sb-tono-${tono}`}>{verdetto}</div>
          <div className="sb-d-tessera__qualificatore">{qualificatore}</div>
          {azione}
        </>
      )}
    </div>
  );
}
